import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Render Gemini-extracted document content. The extraction prompt asks
 * for Markdown tables on tabular sections + plain paragraphs elsewhere,
 * so this component is intentionally minimal: just react-markdown with
 * GFM (tables) and a tight CSS shell sized to live inside the note row.
 *
 * dir="auto" lets RTL strings (Hebrew invoices) flow right-to-left
 * automatically, while pipe-tables themselves stay LTR — the table
 * tag's `dir` is "ltr" via CSS so column order matches the source.
 */
export function ExtractedMarkdown({ text }: { text: string }) {
  return (
    <div
      className="extracted-md"
      dir="auto"
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {text}
      </ReactMarkdown>
    </div>
  );
}
